import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExternalServicesListLayer from "../components/ExternalServicesListLayer";

const ExternalServicesPage = () => {
  return (
    <>
      <MasterLayout pageTitle="External Services">
        <ExternalServicesListLayer />
      </MasterLayout>
    </>
  );
};

export default ExternalServicesPage;
